import { useLazyRef } from '../../../shared/lib/hooks.ts'
import { useSnapshot } from 'valtio/react'
import { useAppModule } from '../../appContext.ts'
import {
  ExerciseButton,
  ExerciseContainer,
  ExerciseTitle,
} from '../exerciseComponents.tsx'
import { TaskSlider } from '../taskSlider/TaskSlider.tsx'
import { TestQuestion } from '../../../shared/api/userTestsApi.ts'
import { TestQuestionsExerciseStore } from './testQuestionsExerciseStore.ts'
import { Payload } from '../../../shared/lib/utils.ts'
import { useEffect } from 'react'
import { useUserTestLessonStore } from '../../userTestLessons/userTestLessonView.tsx'

interface TestQuestionsExerciseProps {
  questions: readonly TestQuestion[]
  completed: boolean
  onComplete: (
    result: string,
    correctAnswersCount: number,
    payload: Payload[],
  ) => void
  questionIndex: number
  allQuestions: readonly TestQuestion[]
}

export const TestQuestionsExercise = (props: TestQuestionsExerciseProps) => {
  const answerStore = useAppModule().answerStatusStore
  const userTestStore = useUserTestLessonStore().userTestLessonStore
  const userTestState = useSnapshot(userTestStore.state)

  const appModule = useAppModule()
  const store = useLazyRef(
    () =>
      new TestQuestionsExerciseStore(
        props.allQuestions,
        answerStore,
        props.onComplete,
        userTestStore,
        appModule.userTestsApi,
      ),
  ).current
  const state = useSnapshot(store.state)

  useEffect(() => {
    const externalIndex = userTestState.currentIndex - 1
    if (store.state.currentIndex !== externalIndex && externalIndex >= 0) {
      store.state.currentIndex = externalIndex
      store.state.currentAnswer = null
      store.state.answerStatus = undefined
    }
  }, [userTestState.currentIndex, store])

  const currentQuestion = state.questions[state.currentIndex]

  const isCorrect = state.answerStatus
    ? state.answerStatus.tag === 'complete'
      ? undefined
      : state.answerStatus.tag === 'correct'
    : undefined

  if (!currentQuestion) {
    return null
  }

  return (
    <ExerciseContainer>
      <TaskSlider
        id={state.currentIndex}
        isLast={state.currentIndex == state.questions.length - 1}
      >
        <div className="flex flex-col items-center">
          <ExerciseTitle
            className="mb-24"
            title={currentQuestion.category || 'Выберите правильный ответ'}
          />
          <p className="mb-40 text-16 font-semibold">
            {currentQuestion.question}
          </p>
          <div className="grid w-full grid-cols-1 gap-12 sm:grid-cols-2 sm:justify-items-center">
            {currentQuestion.options.map((option, index) => {
              const isSelected = state.currentAnswer?.index === index
              const isLastOdd =
                currentQuestion.options.length === 3 && index === 2
              return (
                <ExerciseButton
                  key={`test-question-${state.currentIndex}-${index}`}
                  onClick={() => {
                    store.selectAnswer(index, option)
                  }}
                  isCorrect={
                    isSelected
                      ? isCorrect === undefined
                        ? 'selected'
                        : isCorrect
                        ? 'true'
                        : 'false'
                      : 'none'
                  }
                  className={isLastOdd ? 'sm:col-span-2 sm:max-w-[50%]' : ''}
                >
                  {option}
                </ExerciseButton>
              )
            })}
          </div>
        </div>
      </TaskSlider>
    </ExerciseContainer>
  )
}
